import { createAction } from '../../utils/redux/createAction';

const actionsScope = 'appointment-form/progress';

export const APPOINTMENT_PROGRESS_TYPES = {
  VALIDATE: `${actionsScope}/validate`,
  VALIDATE_FINISH: `${actionsScope}/validate-finish`,
  SET_CARE_USER: `${actionsScope}/set-care-user`,
  SET_ORGANIZATION: `${actionsScope}/set-organization`,
  SET_VISIT_TYPE: `${actionsScope}/set-visit-type`,
  SELECT_VISIT_TYPE: `${actionsScope}/select-visit-type`,
  SET_SERVICE: `${actionsScope}/set-service`,
  SET_LOCATION: `${actionsScope}/set-location`,
  SET_PATIENT_INFO: `${actionsScope}/set-patient-info`,
  SET_SSN: `${actionsScope}/set-ssn`,
  SET_REASON: `${actionsScope}/set-reason`,
  INSPECT_CONSENT: `${actionsScope}/inspect-consent`,
  INSPECT_PATIENT: `${actionsScope}/inspect-patient`,
  UPDATE_NECESSARY_DATA: `${actionsScope}/update-necessary-data`,
  SET_ERROR: `${actionsScope}/set-error`,
  SET_SCHEDULE_DATA: `${actionsScope}/set-schedule-data`,
  FETCH_PROVIDER_LIST: `${actionsScope}/fetch-provider-list`,
  CLEAR: `${actionsScope}/clear`,
  SET_CREATE_TYPE_FLOW_GW: `${actionsScope}/set-create-type-flow`,
  SET_PROGRAM_BASED_VISIT_ID: `${actionsScope}/set-program-based-visit-id`,
  CLEAR_PROGRAM_BASED_VISIT_ID: `${actionsScope}/clear-program-based-visit-id`,
  SELECT_PROGRAM_BASED_VISIT: `${actionsScope}/select-program-based-visit`,
  SET_INSURANCE_ELIGIBILITY: `${actionsScope}/set-insurance-eligibility`,
  SET_HEALTH_INFO: `${actionsScope}/set-health-info`,
  UPDATE_CARE_USER_PROFILE: `${actionsScope}/update-care-user-profile`,
  SET_PREFERRED_PHARMACY: `${actionsScope}/set-preferred-pharmacy`,
  SET_RESCHEDULE_DATA: `${actionsScope}/set-reschedule-data`,
  CLEAR_INSURANCE_ELIGIBILITY: `${actionsScope}/clear-insurance-eligibility`,
  SET_HAVE_CARE_PROVIDER_ANSWER: `${actionsScope}/set-have-care-provider-answer`,
  SET_PENDING: `${actionsScope}/set-pending`,
  SET_FLOW_PAGES: `${actionsScope}/set-flow-pages`,
  REMOVE_FLOW_PAGE: `${actionsScope}/remove-flow-page`,
  SET_PRIMARY_CARE_PROVIDER_FORM_DATA: `${actionsScope}/set-primary-care-provider-form-data`,
  SET_ADDITIONAL_INFO_FORM_DATA: `${actionsScope}/set-additional-info-form-data`,
  DETERMINE_NEXT_STEP_AFTER_EMERGENCY_CONTACT: `${actionsScope}/determine-next-step-after-emergency-contact`,
  DETERMINE_NEXT_STEP_AFTER_GUARANTOR_INFORMATION: `${actionsScope}/determine-next-step-after-guarantor-information`,
  DETERMINE_NEXT_STEP_AFTER_INSURANCE_FORM: `${actionsScope}/determine-next-step-after-insurance-form`,
  DETERMINE_NEXT_STEP_AFTER_VISIT_DETAILS: `${actionsScope}/determine-next-step-after-visit-details`,
  DETERMINE_NEXT_STEP_AFTER_PHARMACY: `${actionsScope}/determine-next-step-after-pharmacy`,
  DETERMINE_NEXT_STEP_AFTER_HEALTH_INFO_PROVIDER_STEP: `${actionsScope}/determine-next-step-after-health-info-provider-step`,
  DETERMINE_NEXT_STEP_AFTER_APPOINTMENT_PROVIDERS: `${actionsScope}/determine-next-step-after-appointment-providers`,
  SET_PREFERRED_LANGUAGE: `${actionsScope}/set-preferred-language`,
};

export const appointmentProgressActions = {
  validate: createAction(APPOINTMENT_PROGRESS_TYPES.VALIDATE),
  finishValidate: createAction(APPOINTMENT_PROGRESS_TYPES.VALIDATE_FINISH),
  setCareUser: createAction(APPOINTMENT_PROGRESS_TYPES.SET_CARE_USER),
  setOrganization: createAction(APPOINTMENT_PROGRESS_TYPES.SET_ORGANIZATION),
  setVisitType: createAction(APPOINTMENT_PROGRESS_TYPES.SET_VISIT_TYPE),
  selectVisitType: createAction(APPOINTMENT_PROGRESS_TYPES.SELECT_VISIT_TYPE),
  setService: createAction(APPOINTMENT_PROGRESS_TYPES.SET_SERVICE),
  setLocation: createAction(APPOINTMENT_PROGRESS_TYPES.SET_LOCATION),
  inspectConsent: createAction(APPOINTMENT_PROGRESS_TYPES.INSPECT_CONSENT),
  inspectPatient: createAction(APPOINTMENT_PROGRESS_TYPES.INSPECT_PATIENT),
  setPatientInfo: createAction(APPOINTMENT_PROGRESS_TYPES.SET_PATIENT_INFO),
  setSSN: createAction(APPOINTMENT_PROGRESS_TYPES.SET_SSN),
  setReason: createAction(APPOINTMENT_PROGRESS_TYPES.SET_REASON),
  setError: createAction(APPOINTMENT_PROGRESS_TYPES.SET_ERROR),
  setHealthInfo: createAction(APPOINTMENT_PROGRESS_TYPES.SET_HEALTH_INFO),
  setHaveCareProviderAnswer: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_HAVE_CARE_PROVIDER_ANSWER,
  ),
  setRescheduleData: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_RESCHEDULE_DATA,
  ),
  updateCareUserProfile: createAction(
    APPOINTMENT_PROGRESS_TYPES.UPDATE_CARE_USER_PROFILE,
  ),
  setScheduleData: createAction(APPOINTMENT_PROGRESS_TYPES.SET_SCHEDULE_DATA),
  setPreferredPharmacy: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_PREFERRED_PHARMACY,
  ),
  setProgramBasedVisitId: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_PROGRAM_BASED_VISIT_ID,
  ),
  clearProgramBasedVisitId: createAction(
    APPOINTMENT_PROGRESS_TYPES.CLEAR_PROGRAM_BASED_VISIT_ID,
  ),
  selectProgramBasedVisit: createAction(
    APPOINTMENT_PROGRESS_TYPES.SELECT_PROGRAM_BASED_VISIT,
  ),
  fetchProviderList: createAction(
    APPOINTMENT_PROGRESS_TYPES.FETCH_PROVIDER_LIST,
  ),
  updateNecessaryData: createAction(
    APPOINTMENT_PROGRESS_TYPES.UPDATE_NECESSARY_DATA,
  ),
  clear: createAction(APPOINTMENT_PROGRESS_TYPES.CLEAR),
  setCreateTypeFlowGW: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_CREATE_TYPE_FLOW_GW,
  ),
  setInsuranceEligibility: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_INSURANCE_ELIGIBILITY,
  ),
  clearInsuranceEligibility: createAction(
    APPOINTMENT_PROGRESS_TYPES.CLEAR_INSURANCE_ELIGIBILITY,
  ),
  setPending: createAction(APPOINTMENT_PROGRESS_TYPES.SET_PENDING),
  setFlowPages: createAction(APPOINTMENT_PROGRESS_TYPES.SET_FLOW_PAGES),
  removeFlowPage: createAction(APPOINTMENT_PROGRESS_TYPES.REMOVE_FLOW_PAGE),
  setPrimaryCareProviderFormData: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_PRIMARY_CARE_PROVIDER_FORM_DATA,
  ),
  setAdditionalInfoFormData: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_ADDITIONAL_INFO_FORM_DATA,
  ),
  determineNextStepAfterEmergencyContact: createAction(
    APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_EMERGENCY_CONTACT,
  ),
  determineNextStepAfterGuarantorInformation: createAction(
    APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_GUARANTOR_INFORMATION,
  ),
  determineNextStepAfterInsuranceForm: createAction(
    APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_INSURANCE_FORM,
  ),
  determineNextStepAfterVisitDetails: createAction(
    APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_VISIT_DETAILS,
  ),
  determineNextStepAfterPharmacy: createAction(
    APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_PHARMACY,
  ),
  determineNextStepAfterHealthInfoProvider: createAction(
    APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_HEALTH_INFO_PROVIDER_STEP,
  ),
  determineNextStepAfterAppointmentProviders: createAction(
    APPOINTMENT_PROGRESS_TYPES.DETERMINE_NEXT_STEP_AFTER_APPOINTMENT_PROVIDERS,
  ),
  setPreferredLanguage: createAction(
    APPOINTMENT_PROGRESS_TYPES.SET_PREFERRED_LANGUAGE,
  ),
};



// WEBPACK FOOTER //
// ./src/redux/appointmentForm/progress-types.js